/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/warenkorb-table/shop.warenkorb-table.component.ts.
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {ShopWarenkorbTableInterface} from '../../interfaces/shop.warenkorb-table-interface';
import {AppViewService} from '../../../../services/app.view.service';
import {Warenkorb} from '../../../../models/warenkorb';
import {AppMobileService} from '../../../../services/app.mobile.service';
import {ViewSettings} from '../../../../models/view-settings';
import {BehaviorSubject} from 'rxjs';
import {AppAsyncTimeout} from '../../../../helpers/app.asyncTimeout';
import {Artikel} from '../../../../models/artikel';
import {ArtikelAktion} from '../../../../models/artikel-aktion';
import {ArtikelWithAktionen} from '../../../../models/artikel-with-aktionen';
import {ArtikelVerfuegbarkeit} from '../../../../models/artikel-verfuegbarkeit';
import {ShopEinkaufsstatistikwebInterface} from '../../interfaces/shop.einkaufsstatistikweb-interface';
import {ShopAktionenInterface} from '../../interfaces/shop.aktionen-interface';
import {AppSettingsService} from '../../../../services/app.app_settings.service';
import {AppConfigService} from '../../../../services/app.config.service';

/**
 * Zweck: Beschreibt class ShopWarenkorbTableComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: '[warenkorb-table]',
    templateUrl: 'shop.warenkorb-table.component.html',
    styleUrls: ['shop.warenkorb-table.component.scss'],
    standalone: false
})
export class ShopWarenkorbTableComponent implements OnInit, OnDestroy, OnChanges, ShopEinkaufsstatistikwebInterface, ShopAktionenInterface {
  @Input() title: string;
  @Input() positionen: WarenkorbEntry[];
  @Input() parent: ShopWarenkorbTableInterface;
  @Input() show_category = true;
  @Input() actions = true;
  @Input() warenkorb: Warenkorb;
  @Input() positionVerfuegbarkeiten: ArtikelVerfuegbarkeit[];
  @Input() summe: any;
  @Input() ajax_mode = false;
  @Input() supplierId: any;
  @Input() positionenFilter: string;

  @Input() active_fields: string[] = [];


  selectedEntriesList = {};


  @Input() selectMode = false;


  @Input() selectedEntries: WarenkorbEntry[] = [];
  @Output() selectedEntriesChange = new EventEmitter<WarenkorbEntry[]>();

  @Input() valid = true;
  @Output() validChange = new EventEmitter();

  visible_artikel_aktionen = new BehaviorSubject<any>({});
  visible_artikel_einkaufsstatistik = new BehaviorSubject<any>({});

  @Input() view_settings: ViewSettings[] | any;

  visiblePositions = new BehaviorSubject<any>(null);

  posTimeouts = {};

  @Input() showAktionenDefault = false;
  @Input() showEinkaufsstatistikWebDefault = false;

/**
 * Beschreibt Methode selectedEntriesListChanged und ihren Rückgabevertrag.
 */
  selectedEntriesListChanged() {
    const list = [];
    Object.keys(this.selectedEntriesList).forEach(id => {

      if (this.selectedEntriesList[id] == true) {
        this.positionen.forEach(p => {
          if (p.id.toString() == id) {
            list.push(p);
          }
        });
      }
    });
    this.selectedEntries = list;
    this.selectedEntriesChange.emit(this.selectedEntries);
  }

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public vsvc: AppViewService, public msvc: AppMobileService, private elref: ElementRef,
              private cd: ChangeDetectorRef, private settsvc: AppSettingsService, public cfg: AppConfigService) {
  }

/**
 * Liefert den Tooltip für die gewählte Import-Hinweis-Option.
 */
  getImportHinweisTooltip(option: string): string {
    if (option === 'exception') {
      return 'Importmeldung - Ausnahme gewählt';
    }
    if (option === 'selfReport') {
      return 'Importmeldung - Selbstmeldung gewählt';
    }
    return null;
  }

/**
 * Beschreibt Methode disableEntryDeleteClick und ihren Rückgabevertrag.
 */
  disableEntryDeleteClick(e) {
    e.disableDeleteButton = true;
    AppAsyncTimeout.setTimeout(() => {
      e.disableDeleteButton = false;
    }, 1000);
  }

/**
 * Beschreibt Methode deletePosition und ihren Rückgabevertrag.
 */
  deletePosition(entry: WarenkorbEntry) {
    if (!entry.gui_disableDeleteButton) {
      this.parent.deletePosition(entry);
    }
  }

/**
 * Beschreibt Methode showEinkaufsStatistikWeb und ihren Rückgabevertrag.
 */
  showEinkaufsStatistikWeb(artikel: Artikel) {
    const statRegistry = this.visible_artikel_einkaufsstatistik.value;
    statRegistry[artikel.Artikelstamm + artikel.ArtikelNummer] = artikel.EinkaufsStatistikWeb;
    this.visible_artikel_einkaufsstatistik.next(statRegistry);
  }


/**
 * Beschreibt Methode hideEinkaufsStatistikWeb und ihren Rückgabevertrag.
 */
  hideEinkaufsStatistikWeb(artikel: Artikel) {
    const statRegistry = this.visible_artikel_einkaufsstatistik.value;
    delete statRegistry[artikel.Artikelstamm + artikel.ArtikelNummer];
    this.visible_artikel_einkaufsstatistik.next(statRegistry);
  }

/**
 * Beschreibt Methode showAktion und ihren Rückgabevertrag.
 */
  showAktion(artikel: Artikel, aktionen: ArtikelAktion[]) {
    const a = new ArtikelWithAktionen();
    a.artikel = artikel;
    a.aktionen = aktionen;
    const aktionenRegistry = this.visible_artikel_aktionen.value;
    aktionenRegistry[artikel.Artikelstamm + artikel.ArtikelNummer] = a;
    this.visible_artikel_aktionen.next(aktionenRegistry);
  }

/**
 * Beschreibt Methode hideAktionen und ihren Rückgabevertrag.
 */
  hideAktionen(artikel: Artikel) {
    const aktionenRegistry = this.visible_artikel_aktionen.value;
    delete aktionenRegistry[artikel.Artikelstamm + artikel.ArtikelNummer];
    this.visible_artikel_aktionen.next(aktionenRegistry);
  }

  private detectChanges() {
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }

/**
 * Beschreibt Methode filterPositionen und ihren Rückgabevertrag.
 */
  filterPositionen() {
    if (this.positionenFilter && this.positionenFilter.length > 0) {
      const found = [];
      this.positionen.forEach(p => {
        if (p.artikel.label.toLowerCase().includes(this.positionenFilter.toLowerCase())) {
          found.push(p.id);
        }
      });
      this.visiblePositions.next(found);
    } else {
      this.visiblePositions.next(null);
    }
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges): void {
    this.detectChanges();
    if (changes.title) {
      setTimeout(() => {
        this.detectChanges();
      }, 1200);

    }
    if (changes.positionenFilter) {
      this.filterPositionen();
    }
  }

/**
 * Beschreibt Methode validate und ihren Rückgabevertrag.
 */
  validate() {
    let valid = true;
    this.positionen.forEach(e => {
      if (!e.valid) {
        valid = false;
      }
    });
    this.valid = valid;
    this.validChange.emit(this.valid);
  }

/**
 * Beschreibt Methode updatePosition und ihren Rückgabevertrag.
 */
  updatePosition(idx, entry: WarenkorbEntry) {
    entry.gui_previousMenge = this.positionen[idx].menge;
    this.positionen[idx].dirty = entry.dirty;
    if (this.posTimeouts[entry.id]) {
      clearTimeout(this.posTimeouts[entry.id]);
    }
    this.valid = false;
    this.validChange.emit(this.valid);

    this.posTimeouts[entry.id] = setTimeout(() => {
      this.positionen[idx] = entry;
      this.validate();
      if (entry.dirty) {
        this.parent.updatePosition(entry);
      }
    }, 1000);
  }

/**
 * Beschreibt Methode addNoteLine und ihren Rückgabevertrag.
 */
  addNoteLine(entry: WarenkorbEntry) {
    if (entry.note.length < 20) {
      this.validate();
      this.parent.addNoteLine(entry);

      AppAsyncTimeout.setTimeout(
        () => {
          const lines = this.elref.nativeElement.querySelectorAll('.nodeline_' + entry.id);
          if (lines.item(lines.length - 1)) {
            lines.item(lines.length - 1).focus();
          }
        },
        250
      );
    }
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
  }


/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    AppAsyncTimeout.setTimeout(() => {
      this.validate();
    }, 400);
  }


}
